@if (
  ProposalRequestFormGroup &&
  LocalizationInfo &&
  SubNationalDivisions.length > 0 &&
  Company &&
  LoggedInUser
) {
  <form class="container-fluid p-0" [formGroup]="ProposalRequestFormGroup">
    <!-- Work Location -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <form
            [formGroup]="ProposalRequestFormGroup.controls['Address']"
            class="qsb-form-section"
          >
            <div class="qsb-section-head">
              <h3 class="mb-0">Work location</h3>
              @if (isSiteSet()) {
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  [disabled]="disableInput"
                  (click)="removeCurrentSiteLocation()"
                >
                  Remove current site location
                </button>
              }
              @if (!isSiteSet()) {
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  [disabled]="disableInput"
                  (click)="setCurrentSiteLocation()"
                >
                  Set current site location
                </button>
              }
            </div>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-addr1">
                    Address 1
                  </label>
                  <input
                    id="qsb-addr1"
                    type="text"
                    class="form-control"
                    formControlName="address1"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label" for="qsb-addr2">Address 2</label>
                  <input
                    id="qsb-addr2"
                    type="text"
                    class="form-control"
                    formControlName="address2"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-city">
                    City
                  </label>
                  <input
                    id="qsb-city"
                    type="text"
                    class="form-control"
                    formControlName="city"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-state">
                    {{ LocalizationInfo.territory.label }}
                  </label>
                  <select
                    id="qsb-state"
                    class="form-select"
                    formControlName="state"
                  >
                    @for (
                      SubNationalDivision of SubNationalDivisions;
                      track SubNationalDivision
                    ) {
                      <option [ngValue]="SubNationalDivision.abbreviation">
                        {{ SubNationalDivision.abbreviation }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-zip">
                    {{ LocalizationInfo.postalCode.label }}
                  </label>
                  <input
                    id="qsb-zip"
                    type="text"
                    class="form-control"
                    formControlName="zip"
                    placeholder="{{ LocalizationInfo.postalCode.format }}"
                    [inputMask]="
                      Company.country === 'US' ? usZipMask : canadianZipMask
                    "
                  />
                </div>
              </div>
            </div>
          </form>
        </app-display-card>
      </div>
    </div>

    <!-- Bid Contact -->
    <div class="row">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-form-section">
            <div class="qsb-section-head">
              <h3 class="mb-0">Bid contact</h3>
              @if (isContactSet()) {
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  [disabled]="disableInput"
                  (click)="removeContact()"
                >
                  Remove contact
                </button>
              }
              @if (!isContactSet()) {
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  [disabled]="disableInput"
                  (click)="setContact()"
                >
                  Set contact
                </button>
              }
            </div>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    class="form-label"
                    requiredAsterisk
                    for="qsb-firstName"
                  >
                    First name
                  </label>
                  <input
                    id="qsb-firstName"
                    type="text"
                    class="form-control"
                    formControlName="contactFirstName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-lastName">
                    Last name
                  </label>
                  <input
                    id="qsb-lastName"
                    type="text"
                    class="form-control"
                    formControlName="contactLastName"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="form-label" requiredAsterisk for="qsb-phone">
                    Phone
                  </label>
                  <input
                    id="qsb-phone"
                    type="text"
                    class="form-control"
                    formControlName="contactPhone"
                    placeholder="(___) ___-____"
                    [inputMask]="phoneMask"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="form-label" for="qsb-ext">Ext.</label>
                  <input
                    id="qsb-ext"
                    type="text"
                    class="form-control"
                    formControlName="contactPhoneExt"
                    [inputMask]="phoneExtensionMask"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="form-label" for="qsb-workPhone">
                    Work phone
                  </label>
                  <input
                    id="qsb-workPhone"
                    type="text"
                    class="form-control"
                    formControlName="contactPhone2"
                    placeholder="(___) ___-____"
                    [inputMask]="phoneMask"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="form-label" for="qsb-workPhoneExt">
                    Work phone ext.
                  </label>
                  <input
                    id="qsb-workPhoneExt"
                    type="text"
                    class="form-control"
                    formControlName="contactPhone2Ext"
                    [inputMask]="phoneExtensionMask"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk>Email</label>
                  <app-email-tagfield
                    [Emails]="ContactEmails"
                    (addedEmail)="addEmail($event)"
                  ></app-email-tagfield>
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>
  </form>
}
